import { createFileRoute } from "@tanstack/react-router";
import { CargarZipPage } from "@/features/cargar-zip/components/CargarZipPage";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";
import { ErrorAlert } from "@/components/ui";

export const Route = createFileRoute("/_authed-tw/solicitudes/$id/cargar-zip")({
  loader: ({ context: { queryClient }, params: { id } }) => queryClient.ensureQueryData(solicitudQueryOptions(id)),
  component: CargarZipPage,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
